(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[214],{

/***/ 1748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery",
      function () {
        return __webpack_require__(7342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const Gallerymodal = (param)=>{
    let { galleryImages , currentIndex , setClickedImage  } = param;
    const [currentImageIndex, setCurrentImageIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentIndex);
    const [clickedImage, setClickedImageLocal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(galleryImages[currentIndex].bgImage || galleryImages[currentIndex].video);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setClickedImageLocal(galleryImages[currentImageIndex].bgImage || galleryImages[currentImageIndex].video);
    }, [
        currentImageIndex,
        galleryImages
    ]);
    const handleRotationRight = ()=>{
        const totalLength = galleryImages.length;
        if (currentImageIndex + 1 >= totalLength) {
            setCurrentImageIndex(0);
            return;
        }
        setCurrentImageIndex(currentImageIndex + 1);
    };
    const handleRotationLeft = ()=>{
        const totalLength = galleryImages.length;
        if (currentImageIndex === 0) {
            setCurrentImageIndex(totalLength - 1);
            return;
        }
        setCurrentImageIndex(currentImageIndex - 1);
    };
    const handleClick = (e)=>{
        if (e.target.classList.contains("dismiss")) {
            setClickedImage(null);
        }
    };
    const currentItem = galleryImages[currentImageIndex];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "modal_overlay dismiss",
            onClick: handleClick,
            children: [
                currentItem.bgImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: "modal_image",
                    src: clickedImage,
                    alt: "bigger picture"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
                    className: "modal_video",
                    controls: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: clickedImage,
                            type: "video/mp4"
                        }),
                        "Your browser does not support the video tag."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "dismiss close_icon",
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/close-white.svg",
                        className: "dismiss",
                        width: 20,
                        height: 20,
                        alt: "Close arrow icon"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: handleRotationLeft,
                    className: "overlay-arrows_left",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/left-white.svg",
                        width: 30,
                        height: 30,
                        alt: "Left Icon"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: handleRotationRight,
                    className: "overlay-arrows_right",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/right-white.svg",
                        width: 30,
                        height: 30,
                        alt: "Right Icon"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Gallerymodal);


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/styles/pages/Restaurant.module.scss
var Restaurant_module = __webpack_require__(1027);
var Restaurant_module_default = /*#__PURE__*/__webpack_require__.n(Restaurant_module);
// EXTERNAL MODULE: ./src/components/Topbanner/Topbanner.js
var Topbanner = __webpack_require__(6240);
// EXTERNAL MODULE: ./src/components/PageGalleryComp/PageGalleryComp.module.scss
var PageGalleryComp_module = __webpack_require__(4933);
var PageGalleryComp_module_default = /*#__PURE__*/__webpack_require__.n(PageGalleryComp_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Gallerymodal/Gallerymodal.js
var Gallerymodal = __webpack_require__(1556);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/PageGalleryComp/PageGalleryComp.js





function SkeletonLoader() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PageGalleryComp_module_default()).skeletonLoader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (PageGalleryComp_module_default()).skeletonImage
        })
    });
}
;
function PageGalleryComp(param) {
    let { galleryImages  } = param;
    const [selectedCategory, setSelectedCategory] = (0,react.useState)("all");
    const [clickedImage, setClickedImage] = (0,react.useState)(null);
    const [currentIndex, setCurrentIndex] = (0,react.useState)(null);
    const [visibleImages, setVisibleImages] = (0,react.useState)(9); // Initial number of images to show
    const [loading, setLoading] = (0,react.useState)(true);
    const categories = [
        ...new Set(galleryImages.map((image)=>image.category))
    ];
    const filteredImages = selectedCategory === "all" ? galleryImages : galleryImages.filter((image)=>image.category === selectedCategory);
    (0,react.useEffect)(()=>{
        setLoading(true);
        const timer = setTimeout(()=>setLoading(false), 1000); // Adjust as needed
        return ()=>clearTimeout(timer);
    }, [
        selectedCategory
    ]);
    const handleClick = (item, index)=>{
        const originalIndex = galleryImages.findIndex((image)=>image.bgImage === item.bgImage);
        setCurrentIndex(originalIndex);
        setClickedImage(item.bgImage || item.video);
    };
    const loadMoreImages = ()=>{
        setLoading(true); // Reset loading state
        setVisibleImages((prevVisibleImages)=>prevVisibleImages + 9);
        const timer = setTimeout(()=>setLoading(false), 1000); // Simulate loading
        return ()=>clearTimeout(timer);
    };
    const formatCategory = (category)=>{
        return category.split("_").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex gap-2 justify-content-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>setSelectedCategory("all"),
                        className: selectedCategory === "all" ? "filtered_btn secound_common_btn" : "secound_common_btn",
                        children: "All"
                    }),
                    categories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>setSelectedCategory(category),
                            className: selectedCategory === category ? "filtered_btn secound_common_btn" : "secound_common_btn",
                            children: formatCategory(category)
                        }, category))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageGalleryComp_module_default()).gallery_page_comp,
                children: loading ? Array.from({
                    length: visibleImages
                }).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PageGalleryComp_module_default()).gallery_page_comp_child,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader, {})
                    }, index)) : filteredImages.slice(0, visibleImages).map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PageGalleryComp_module_default()).gallery_page_comp_child,
                        children: item.bgImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: item.bgImage,
                            fill: true,
                            alt: item.altText,
                            onClick: ()=>handleClick(item, index)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            controls: true,
                            onClick: ()=>handleClick(item, index),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: item.video,
                                    type: "video/mp4"
                                }),
                                "Your browser does not support the video tag."
                            ]
                        })
                    }, index))
            }),
            filteredImages.length > visibleImages && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: loadMoreImages,
                    className: "common_btn mt-4",
                    children: "Load More"
                })
            }),
            clickedImage !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallerymodal/* default */.Z, {
                galleryImages: galleryImages,
                currentIndex: currentIndex,
                setClickedImage: setClickedImage
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/gallery.js





function Gallery() {
    const galleryImages = [
        // Facade
        {
            bgImage: "/images/page-gallery/facade/8.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/17.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: "facade"
        },
        // Rooms
        {
            bgImage: "/images/page-gallery/rooms/executive/1.jpg",
            altText: "The Twin Towers Hotel Room Image 1",
            category: "rooms"
        },
        {
            bgImage: "/images/page-gallery/rooms/executive/2.jpg",
            altText: "The Twin Towers Hotel Room Image 6",
            category: "rooms"
        },
        // Dining
        {
            bgImage: "/images/page-gallery/dining/8.jpg",
            altText: "The Twin Towers Hotel dining Image 8",
            category: "dining"
        },
        {
            bgImage: "/images/page-gallery/dining/2.jpg",
            altText: "The Twin Towers Hotel dining Image 3",
            category: "dining"
        },
        // Meeting
        {
            bgImage: "/images/page-gallery/wedding-events/1.jpg",
            altTest: "Wedding image 1",
            category: "wedding_&_events"
        },
        // View
        {
            bgImage: "/images/page-gallery/views/2.jpg",
            altText: "The Twin Towers Hotel View Image 2",
            category: "property_view"
        },
        // Wildlife Nature
        {
            bgImage: "/images/page-gallery/wild-nature/2.jpg",
            altText: "The Twin Towers Hotel View Image 2",
            category: "wildlife_&_nature"
        },
        // Rooms
        // {
        //     bgImage: "/images/page-gallery/rooms/family-room/1.jpg",
        //     altText: "The Twin Towers Hotel Room Image 1",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/deluxe/3.jpg",
            altText: "The Twin Towers Hotel Room Image 6",
            category: "rooms"
        },
        {
            bgImage: "/images/page-gallery/rooms/deluxe/4.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: "rooms"
        },
        // {
        //     bgImage: "/images/page-gallery/rooms/deluxe/5.jpg",
        //     altText: "The Twin Towers Hotel Room Image 2",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/family-room/3.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: "rooms"
        },
        // {
        //     bgImage: "/images/page-gallery/rooms/premier/1.jpg",
        //     altText: "The Twin Towers Hotel Room Image 2",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/premier/2.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: "rooms"
        },
        {
            bgImage: "/images/page-gallery/rooms/premier/4.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: "rooms"
        },
        // {
        //     bgImage: "/images/page-gallery/rooms/wash-room/3.jpg",
        //     altText: "The Twin Towers Hotel wash room Image 2",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/wash-room/6.jpg",
            altText: "The Twin Towers Hotel wash room Image 2",
            category: "rooms"
        },
        // Dining
        {
            bgImage: "/images/page-gallery/dining/1.jpg",
            altText: "The Twin Towers Hotel dining Image 1",
            category: "dining"
        },
        {
            bgImage: "/images/page-gallery/dining/3.jpg",
            altText: "The Twin Towers Hotel dining Image 3",
            category: "dining"
        },
        // {
        //     bgImage: "/images/page-gallery/dining/4.jpg",
        //     altText: "The Twin Towers Hotel dining Image 4",
        //     category: "dining"
        // },
        // {
        //     bgImage: "/images/page-gallery/dining/5.jpg",
        //     altText: "The Twin Towers Hotel dining Image 5",
        //     category: "dining"
        // },
        {
            bgImage: "/images/page-gallery/dining/6.jpg",
            altText: "The Twin Towers Hotel dining Image 6",
            category: "dining"
        },
        {
            bgImage: "/images/page-gallery/dining/7.jpg",
            altText: "The Twin Towers Hotel dining Image 7",
            category: "dining"
        },
        // {
        //     bgImage: "/images/page-gallery/dining/9.jpg",
        //     altText: "The Twin Towers Hotel dining Image 9",
        //     category: "dining"
        // },
        // {
        //     bgImage: "/images/page-gallery/dining/10.jpg",
        //     altText: "The Twin Towers Hotel dining Image 10",
        //     category: "dining"
        // },
        {
            bgImage: "/images/page-gallery/dining/11.jpg",
            altText: "The Twin Towers Hotel dining Image 11",
            category: "dining"
        },
        // {
        //     bgImage: "/images/page-gallery/dining/12.jpg",
        //     altText: "The Twin Towers Hotel dining Image 12",
        //     category: "dining"
        // },
        // Facade
        // {
        //     bgImage: "/images/page-gallery/facade/1.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 1",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/2.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 2",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/4.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 4",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/5.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 5",
        //     category: "facade"
        // },
        {
            bgImage: "/images/page-gallery/facade/6.jpg",
            altText: "The Twin Towers Hotel Facade Image 6",
            category: "facade"
        },
        // {
        //     bgImage: "/images/page-gallery/facade/7.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 7",
        //     category: "facade"
        // },
        {
            bgImage: "/images/page-gallery/facade/8.jpg",
            altText: "The Twin Towers Hotel Facade Image 8",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/9.jpg",
            altText: "The Twin Towers Hotel Facade Image 9",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/10.jpg",
            altText: "The Twin Towers Hotel Facade Image 10",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/11.jpg",
            altText: "The Twin Towers Hotel Facade Image 11",
            category: "facade"
        },
        // {
        //     bgImage: "/images/page-gallery/facade/12.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 12",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/13.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 13",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/14.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 14",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/15.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 15",
        //     category: "facade"
        // },
        {
            bgImage: "/images/page-gallery/facade/16.jpg",
            altText: "The Twin Towers Hotel Facade Image 16",
            category: "facade"
        },
        // Wedding Events
        {
            bgImage: "/images/page-gallery/wedding-events/4.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 4",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/2.jpg",
            altTest: "Wedding image 2",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/5.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 5",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/6.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 6",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/7.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 7",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/8.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 8",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/9.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 9",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/10.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 10",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/11.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 11",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/12.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 12",
            category: "wedding_&_events"
        },
        {
            bgImage: "/images/page-gallery/wedding-events/13.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 13",
            category: "wedding_&_events"
        },
        // Property View
        {
            bgImage: "/images/page-gallery/views/3.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/4.jpg",
            altText: "The Twin Towers Hotel View Image 4",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/5.jpg",
            altText: "The Twin Towers Hotel View Image 5",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/6.jpg",
            altText: "The Twin Towers Hotel View Image 6",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/7.jpg",
            altText: "The Twin Towers Hotel View Image 7",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/8.jpg",
            altText: "The Twin Towers Hotel View Image 8",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/background.jpg",
            altText: "The Twin Towers Hotel View Image 10",
            category: "property_view"
        },
        // Wildlife Nature
        {
            bgImage: "/images/page-gallery/wild-nature/3.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: "wildlife_&_nature"
        },
        {
            bgImage: "/images/page-gallery/wild-nature/4.jpg",
            altText: "The Twin Towers Hotel View Image 4",
            category: "wildlife_&_nature"
        },
        {
            bgImage: "/images/page-gallery/wild-nature/5.jpg",
            altText: "The Twin Towers Hotel View Image 5",
            category: "wildlife_&_nature"
        },
        {
            bgImage: "/images/page-gallery/wild-nature/6.jpg",
            altText: "The Twin Towers Hotel View Image 6",
            category: "wildlife_&_nature"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Gallery | The Twin Towers Hotel in Kufri, Shimla"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Discover our carefully selected collection of beautiful images highlighting our wide range of offerings - The Twin Towers Hotel in Shimla"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/gallery"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Restaurant_module_default()).gallery_sec, " common_padding"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Restaurant_module_default()).gallery_sec_heading, " text-center common_title pt-5"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: "Gallery"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Explore our curated collection of stunning images showcasing our diverse offerings"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageGalleryComp, {
                            galleryImages: galleryImages
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 4933:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery_page_comp":"PageGalleryComp_gallery_page_comp__YCZqp","gallery_page_comp_child":"PageGalleryComp_gallery_page_comp_child__AJgLE","skeletonLoader":"PageGalleryComp_skeletonLoader__oG5DE","skeletonImage":"PageGalleryComp_skeletonImage__PMMkm","loading":"PageGalleryComp_loading__mIpP_"};

/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 1027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"restaurant_banner":"Restaurant_restaurant_banner__R8ast","banner_text":"Restaurant_banner_text___9T0g","banner_text_con":"Restaurant_banner_text_con__qD_Ea","wedding_meeting_banner":"Restaurant_wedding_meeting_banner__ol2Kp","banner_btn":"Restaurant_banner_btn__eYnP2","bounce":"Restaurant_bounce__ZHKzx","restaurant":"Restaurant_restaurant__8q4_f","restaurant_top":"Restaurant_restaurant_top__nDa3F","res_top_left":"Restaurant_res_top_left__tXWa1","center_div":"Restaurant_center_div__Sk0Vx","res_top_right":"Restaurant_res_top_right__Xu2zR","restaurant_top_two":"Restaurant_restaurant_top_two__y4pf_","res_top_left_two":"Restaurant_res_top_left_two__NJzvY","res_top_right_two":"Restaurant_res_top_right_two__tDjXI","restaurant_gal":"Restaurant_restaurant_gal__6zZeh","gallery_main":"Restaurant_gallery_main__r__8l","gallery_child":"Restaurant_gallery_child__FKNBV","image_sec":"Restaurant_image_sec__0F8ZR","bar_image":"Restaurant_bar_image__Iphap","best_venue_sec":"Restaurant_best_venue_sec__D_IFJ","best_venue_sec_main":"Restaurant_best_venue_sec_main__65U0_","wedding_amenities":"Restaurant_wedding_amenities__zxz55","amenities_main":"Restaurant_amenities_main__KH5aM","amenities":"Restaurant_amenities___QyIS","gallery_sec":"Restaurant_gallery_sec__SQk4F","gallery_sec_heading":"Restaurant_gallery_sec_heading__i15fF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1748); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);